import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { useConfigs } from '../lib/config-context';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const OptionalTooltip = ({
  children,
  title,
  disabled,
  useReskin
}) => {
  if (useReskin) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: title,
    disabled: disabled,
    placement: "bottom",
    "data-test-id": "cdb-draggable-card-tooltip",
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
const DragItem = styled.div.withConfig({
  displayName: "DraggableCard__DragItem",
  componentId: "sc-1g8ipmu-0"
})(({
  theme,
  useReskin
}) => `
  padding-inline: ${useReskin ? 'unset' : theme.space['100']};
  padding-block-start: ${useReskin ? 'unset' : theme.space['100']};
  width: 100%;
`);
const DraggableCard = ({
  children,
  cardData,
  index
}) => {
  const {
    useReskin
  } = useConfigs();
  const {
    isDragInProgress,
    getDragPermissionsMessageForCard,
    onColumnChange
  } = useConfigs();
  const dragPermissionsMessage = getDragPermissionsMessageForCard && getDragPermissionsMessageForCard(cardData);
  let isDragDisabled = false; //can drag
  if (!onColumnChange) {
    //no handler no dragging
    isDragDisabled = true;
  } else {
    //original permissions
    isDragDisabled = isDragInProgress || !!dragPermissionsMessage;
  }
  return /*#__PURE__*/_jsx(Draggable, {
    draggableId: cardData.id,
    index: index,
    isDragDisabled: isDragDisabled,
    children: provided => /*#__PURE__*/_jsx(DragItem, Object.assign({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      useReskin: Boolean(useReskin),
      children: /*#__PURE__*/_jsx(OptionalTooltip, {
        title: dragPermissionsMessage,
        disabled: !dragPermissionsMessage,
        useReskin: Boolean(useReskin),
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: children
        })
      })
    }))
  });
};
export default DraggableCard;